import authType from '@/config/authType';
const statusMap = [
  {
    value: 0,
    name: '草稿'
  },
  {
    value: 1,
    name: '启用'
  },
  {
    value: 2,
    name: '禁用'
  }
];
const statusShowMap = {
  0: { name: '草稿', color: 'yellow', statusText: '', statusType: '' },
  1: { name: '启用', color: 'green', statusText: '禁用', statusType: 'error' },
  2: { name: '禁用', color: 'volcano', statusText: '启用', statusType: 'warning' }
};
const formItems = [
  { label: '审批模版名称', model: 'tplName', type: 'input', span: 6 },
  { label: '状态', model: 'status', type: 'selectNormal', span: 6, options: [{ name: '全部', value: '' }, ...statusMap] },
  {
    type: 'button',
    buttonArr: [
      { message: '查询', type: 'primary', fun: 'searchTableInfo' },
      { message: '重置', type: 'warning', fun: 'resetTableInfo' }
    ],
    span: 12
  }
];
const getColumnsMap = (methods) => {
  return {
    tplName: {
      title: '审批模版名称',
      key: 'tplName',
      minWidth: 150
    },
    note: {
      title: '模版描述',
      key: 'note',
      minWidth: 250,
      ellipsis: true,
      tooltip: true
    },
    name: {
      title: '模版组',
      key: 'name',
      minWidth: 150,
      ellipsis: true,
      tooltip: true
    },
    creator: {
      title: '创建人',
      key: 'creator',
      width: 80
    },
    addTime: {
      title: '创建时间',
      key: 'addTime',
      minWidth: 120
    },
    operator: {
      title: '更新人',
      key: 'operator',
      width: 80
    },
    updateTime: {
      title: '更新时间',
      key: 'updateTime',
      minWidth: 120
    },
    status: {
      title: '状态',
      key: 'status',
      width: 90,
      align: 'center',
      render: (h, { row }) => {
        const { status } = row;
        return h('Tag', { props: { color: statusShowMap[status].color } }, statusShowMap[status].name);
      }
    },
    sort: {
      title: '排序权重',
      key: 'sortNum',
      minWidth: 50,
      render: (h, { row }) => {
        const { sortNum } = row;
        return h('div', { style: { textAlign: 'right' } }, sortNum);
      }
    },
    id: {
      title: '审批模版ID',
      key: 'id',
      width: 250
    },
    action: {
      title: '操作',
      align: 'left',
      key: 'action',
      minWidth: 180,
      fixed: 'right',
      render: (h, { row }) => {
        const buttonArr = [];
        const { status, id } = row;
        // status = 0 停用， 1 启用 状态， 所以文字展示要相反
        const { statusText } = statusShowMap[status];
        const { statusType } = statusShowMap[status];
        buttonArr.push(
          h('CustomButton', {
            props: { type: 'success', size: 'small', permissionCode: authType.tplApprovalManage.edit },
            style: { margin: '4px' },
            on: {
              click: () => {
                methods.edit({ type: 'edit', id, status });
              }
            }
          }, '编辑')
        );
        if (status != 0) {
          buttonArr.push(
            h('CustomButton', {
              props: { type: statusType, size: 'small', permissionCode: authType.tplApprovalManage.changeStatus },
              style: { margin: '4px' },
              on: {
                click: () => {
                  methods.toggleStatus({ id, status, statusText });
                }
              }
            }, statusText)
          );

          buttonArr.push(
            h('CustomButton', {
              props: { type: 'primary', size: 'small', permissionCode: authType.tplApprovalManage.copy },
              style: { margin: '4px' },
              on: {
                click: () => {
                  methods.copy({ id, status });
                }
              }
            }, '复制')
          );
        }
        return h('div', { style: { 'text-align': 'left' } }, buttonArr);
      }
    }
  };
};
const getColumns = (methods, noShowArr) => {
  const columnsMap = getColumnsMap(methods);
  const keyArr = Object.keys(columnsMap);
  const columns = [];
  keyArr.forEach(key => {
    if (!noShowArr || !noShowArr.includes(key)) {
      columns.push(columnsMap[key]);
    }
  });
  return columns;
};
export { formItems, getColumns };
